import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "../sidebar/App";

/* global document, Office */

const container = document.getElementById("root");
const root = container ? createRoot(container) : undefined;

Office.onReady(() => {
  root?.render(<App />);
});
